export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-list.vue?vue&type=template&id=438db8fa"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/game-list/game-list.vue?vue&type=template&id=438db8fa
// module id = LfqT
// module chunks = 0